import React, { Children, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { range } from 'lodash';
import classnames from 'classnames';
import { stringify } from 'querystring';

import { scrollToElement } from 'lib/helpers';
import { Paragraph } from 'components/core/Typography';
import { PaginationSummary } from 'components/core/Pagination';
import NewPagination from 'components/core/Pagination/NewPagination';

import './reviewList.scss';

class ReviewList extends PureComponent {
	_onPageChange = () => {
		scrollToElement('.review-list', {
			offset: -16,
			behavior: 'smooth'
		});
	};

	_renderReviewPage() {
		const { pageSize, currentPage } = this.props;
		const start = (pageSize * (currentPage - 1));
		return Children.toArray(this.props.children).slice(start, start + pageSize);
	}

	_getPages() {
		const totalReviews = this.props.children.length;
		const totalPages = Math.ceil(totalReviews / this.props.pageSize);

		return range(0, totalPages).map((index) => ({
			to: this._buildPaginationLink({
				reviewPage: index + 1
			}),
			pageNumber: index + 1
		}));
	}

	_buildPaginationLink(queryParams) {
		return `${this.props.facilityUrl}?${stringify(queryParams)}`;
	}

	render() {
		return (
			<div className={classnames(this.props.className, 'review-list')}>
				{!!this.props.children.length &&
					<Paragraph eyebrow>
						<PaginationSummary
							label=" reviews"
							page={this.props.currentPage}
							itemsPerPage={this.props.pageSize}
							totalItems={this.props.children.length}
							prefix="Showing"
						/>
					</Paragraph>
				}
				<ul className="list">
					{this._renderReviewPage()}
				</ul>
				<NewPagination
					pages={this._getPages()}
					selectedPage={this.props.currentPage}
					onPageChange={this._onPageChange}
				/>
			</div>
		);
	}
}

ReviewList.propTypes = {
	className: PropTypes.string,
	/** Array of Review components */
	children: PropTypes.node,
	/** How many reviews to show per page */
	pageSize: PropTypes.number,
	/** The current page to show */
	currentPage: PropTypes.number,
	/** The url to the facility's page */
	facilityUrl: PropTypes.string.isRequired
};

ReviewList.defaultProps = {
	children: [],
	pageSize: 5,
	currentPage: 1
};

export default ReviewList;
